import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShaderEffect: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconShaderEffect"><Path d="M20.2227 3.83691C20.7029 4.33201 21 5.00577 21 5.75V18.25C21 19.7688 19.7688 21 18.25 21H5.75C5.00577 21 4.33201 20.7029 3.83691 20.2227L20.2227 3.83691Z" fill="currentColor"/><Path d="M18.25 3C18.4623 3 18.6687 3.02574 18.8672 3.07129L3.07129 18.8672C3.02574 18.6687 3 18.4623 3 18.25V13.0605L13.0605 3H18.25Z" fill="currentColor"/><Path d="M3 10.9395V5.75C3 4.23122 4.23122 3 5.75 3H10.9395L3 10.9395Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShaderEffect;
